<mat-card>
    <form>
        <mat-card-header>
            <mat-card-title class="mat-card-title-custom">
                <span>{{ "title.result_sync_customer" | translate }}</span>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content class="mb-3 mat-card-content-contract-sm">
            <mat-accordion #accordion="matAccordion" [multi]="true">
                <mat-expansion-panel expanded="true" class="mb-3 mt-3">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-panel-title" style="color: rgba(0,0,0,.87);">
                            {{ "result_sync_customers.sync_customer_info" | translate }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="form-group row">
                        <div class="col-6 d-flex mb-2">
                            <span style="flex: 1;">{{ "result_sync_customers.time_start" | translate }}</span>
                            <span><b>{{ dataResultSync.startTime | datetime }}</b></span>
                        </div>
                        <div class="col-6 d-flex mb-2">
                            <span style="flex: 1;">{{ "result_sync_customers.time_end" | translate }}</span>
                            <span><b>{{ dataResultSync.endTime | datetime }}</b></span>
                        </div>
                        <div class="col-6 d-flex mb-2">
                            <span style="flex: 1;">{{ "result_sync_customers.count_selected_customer" | translate
                                }}</span>
                            <span><b>{{ dataResultSync.total }}</b></span>
                        </div>
                        <div class="col-6 d-flex mb-2">
                            <span style="flex: 1;">{{ "result_sync_customers.count_customer_sync_success" | translate
                                }}</span>
                            <span><b>{{ dataResultSync.done }}</b></span>
                        </div>
                        <div class="col-6 d-flex mb-2">
                            <span style="flex: 1;">{{ "result_sync_customers.count_customer_sync_failed" | translate
                                }}</span>
                            <span><b>{{ dataResultSync.failed }}</b></span>
                        </div>
                        <div class="col-6 d-flex mb-2">
                            <span style="flex: 1;">{{ "result_sync_customers.count_customer_sync_process" | translate
                                }}</span>
                            <span><b>{{ dataResultSync.processing }}</b></span>
                        </div>
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel expanded="true" class="mb-3">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="mat-panel-title">
                            <div class="row" style="width: 100%">
                                <div class="col-4 title-panel" style="color: rgba(0,0,0,.87);">
                                    {{ "result_sync_customers.list_customer_title" | translate }}
                                </div>
                                <div class="col-8 d-flex justify-content-between" *ngIf="processing.percent < 100 && goFrom != 'notification'">
                                    <div class=" title-panel">{{ "import_file.user_processing" | translate }}
                                        ({{ processing.percent }}%) </div>
                                    <div class="d-flex flex-column justify-content-center"
                                        style="width: calc(100% - 200px);">
                                        <mat-progress-bar mode="determinate" [value]="processing.percent"
                                            [bufferValue]="100"></mat-progress-bar>
                                    </div>
                                </div>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="contract-lot-detail">
                        <div class="row">
                            <div class="col-12">
                                <nz-table #rowsTable nzBordered [nzData]="nzData" [nzShowPagination]="false"
                                    [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
                                    <thead>
                                        <tr>
                                            <th class="text-center" nzWidth="55px">
                                                {{ "import_file.table_detail.index" | translate }}
                                            </th>
                                            <th class="text-center" nzWidth="16%" nzEllipsis="true">
                                                {{
                                                "result_sync_customers.table_detail.user_no" | translate
                                                }}
                                            </th>
                                            <th class="text-center" nzWidth="16%" nzEllipsis="true">
                                                {{
                                                "result_sync_customers.table_detail.user_name" | translate
                                                }}
                                            </th>
                                            <th class="text-center" nzWidth="16%" nzEllipsis="true">
                                                {{
                                                "result_sync_customers.table_detail.mst_cmtnd" | translate
                                                }}
                                            </th>
                                            <th class="text-center" nzWidth="15%">
                                                {{ "result_sync_customers.table_detail.result" | translate }}
                                            </th>
                                            <th class="text-center">
                                                {{
                                                "result_sync_customers.table_detail.error_detail" | translate
                                                }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let data of nzData; let i = index; trackBy:identify">
                                            <td class="text-center">{{ i + 1 }}</td>
                                            <td>
                                                {{( data.customerCode ? data.customerCode : null) }}
                                            </td>
                                            <td>
                                                {{( data.name ? data.name : null) }}
                                            </td>
                                            <td>
                                                {{( data.certificateNo ?data.certificateNo : null) }}
                                            </td>
                                            <td class="text-center">
                                                <span [ngStyle]="renderStatusColor(data.status)" class="p-1">{{
                                                    renderStatus(data.status) }}</span>
                                            </td>
                                            <td nz-tooltip [nzTooltipTitle]="data.errorMessage">
                                                {{ data.errorMessage ? (data.errorMessage| slice:0:50) : null }}<span
                                                    *ngIf="data.errorMessage && data.errorMessage.length > 50">...</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </nz-table>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
                <div class="pr-0 ">
                    <div class="text-center mat-elevation-z0 py-2 w-100" style="height: 60px">
                        <button id="btn-cancel" mat-stroked-button color="primary" class="mr-3" type="button"
                             (click)="onClickCancel()">
                            <mat-icon class="mr-0">cancel</mat-icon>
                            {{ "button.close" | translate }}
                        </button>
                        <!-- <button mat-raised-button color="primary" class="mr-3" type="button" (click)="submit()"
                             [disabled]="!fileName">
                            <mat-icon class="mr-0">save</mat-icon>
                            {{ "button.add_customer" | translate }}
                        </button> -->
                    </div>
                </div>
            </mat-accordion>
        </mat-card-content>
    </form>
</mat-card>